<header-web (dataEvent)='setLanguage($event)'></header-web>
<section class="container mi-container px-md-5 px-1 pt-0 pb-5 mb-md-1 mb-5">
    <div class="panel panel-default mi-panel">
        <div class="panel-body container-fluid">
            <form class="form-consultaComprobantes" novalidate role="form" [formGroup]="data">
                <div class="form-horizontal mb-2">
                    <p class="text mi-text">Ingrese los siguientes datos para descargar su comprobante:</p>
                    <hr class="mx-2" style="color: #57BFB3; height: 2px; background-color: #57BFB3;">
                    

                    <div class="form-group mb-3 row">
                        <label for="TipoComprobante" class="control-label fw-bold col-md-3 text-md-end">TIPO COMPROBANTE:</label>
                        <div class="col-md-9">
                            <select name="TipoComprobante" id="TipoComprobante"  class="form-select" formControlName="TipoComprobante" [class.is-invalid]="TipoComprobanteNoValido">
                                <option value="1">Factura</option>
                                <option value="3">Boleta</option>
                                <option value="7">Nota Credito</option>
                                <option value="8">Nota Debito</option>
                            </select>
                            <span class="mi-span" *ngIf="TipoComprobanteNoValido" class="text-danger" style="font-weight: bold; font-size: 12px;">
                                (Tipo de documento no puede quedar vacío)*
                            </span>
                        </div>
                    </div>

                    <div class="form-group mb-3 row">
                        <label for="SerieNumero" class="control-label fw-bold col-md-3 text-md-end">SERIE Y NÚMERO</label>
                        <div class="col-md-9">
                            <input type="text" class="form-control" formControlName="SerieNumero" [class.is-invalid]="SerieNumeroNoValido">
                            <span class="mi-span" *ngIf="SerieNumeroNoValido" class="text-danger" style="font-weight: bold; font-size: 12px;">
                                (Ingrese una serie y número validos)*
                            </span>
                        </div>
                    </div>

                    <div class="form-group mb-3 row">
                        <label for="fechaEmision" class="control-label fw-bold col-md-3 text-md-end">FECHA EMISIÓN</label>
                        <div class="col-md-9">
                            <input type="date" class="form-control" formControlName="FechaEmision" [class.is-invalid]="FechaEmisionNoValido">
                            <span class="mi-span" *ngIf="FechaEmisionNoValido" class="text-danger" style="font-weight: bold; font-size: 12px;">
                                (Ingrese una Fecha de Emisión valida)*
                            </span>
                        </div>
                    </div>

                    <div class="form-group mb-3 row">
                        <label for="montoTotal" class="control-label fw-bold col-md-3 text-md-end">MONTO TOTAL</label>
                        <div class="col-md-9">
                            <input type="text" class="form-control" placeholder="0.00" formControlName="MontoTotal" [class.is-invalid]="MontoTotalNoValido">
                            <span class="mi-span" *ngIf="MontoTotalNoValido" class="text-danger" style="font-weight: bold; font-size: 12px;">
                                (Ingrese el monto total correcto)*
                            </span>
                        </div>
                    </div>

                    <div class="form-group mb-3 row">
                        <label for="rucEmisor" class="control-label fw-bold col-md-3 text-md-end">RUC EMISOR</label>
                        <div class="col-md-9">
                            <input type="text" class="form-control" formControlName="Ruc" [class.is-invalid]="RucNoValido">
                            <span class="mi-span" *ngIf="RucNoValido" class="text-danger" style="font-weight: bold; font-size: 12px;">
                                (Ingrese RUC válido)*
                            </span>
                        </div>
                    </div>

                    <div class="form-group mb-3 row">
                        <label for="codigo" class="control-label fw-bold col-md-3 text-md-end">Captcha</label>
                        
                        <div class="col-md-9">
                            <div class="d-flex align-items-end mb-1">
                                
                                <div class="form-group d-block mr-2 img-captcha">
                                    <div style="width: 100%;" *ngIf="showLoadingSpinner == true">
                                        <mat-spinner mode="indeterminate" *ngIf="showLoadingSpinner == true" [diameter]="40"></mat-spinner>
                                    </div>
            
            
                                    <div style="width: 100%; height: 100%;" *ngIf="showLoadingSpinner == false">
                                        <img [src]="this.capcha64" width="100%" height="100%" class="bmd-img rounded" />
                                    </div>
                                </div>

                                <button class="btn-refresh ms-1" (click)="this.refreshCaptcha()"><i class="fa fa-refresh fa-2xl" aria-hidden="true"></i></button>
                            </div>
                            <div>
                                <input type="text" class="form-control" formControlName="CodigoCaptcha"
                                [class.is-invalid]="CodigoCaptchaNoValido">
                                <span class="mi-span" style="font-weight: bold; font-size: 12px;" *ngIf="CodigoCaptchaNoValido" class="text-danger">
                                    (Error Captcha)
                                    </span>
                            </div>
                        </div>

                        
                    </div>



                    <div class="mis-botones">
                        <button type="button" (click)="procesarComprobantePDF()" class="btn btn-primary">Consultar PDF</button>
                        <a [href]="this.pdf64"></a>
                        <button type="button" (click)="procesarComprobanteXML()" class="btn btn-primary">Descargar XML</button>
                        <button type="button" class="btn btn-primary">Limpiar</button>
                    </div>
                    


                </div>

                <!--<pre>{{ data.value | json }}</pre>-->
            </form>
        </div>
        <div class="panel-footer"></div>
    </div>
    
</section>
<footer-web class="mt-md-1 mt-5"></footer-web>
